import {Column} from 'react-table'
import {DataLrItem} from '../../core/_models'
import {LrCustomHeader} from './LrCustomHeader'
import {LrItemValue} from './LrItemValue'
import {LrItemLine} from './LrItemLine'

const LrColumns: Column<DataLrItem>[] = [
  {
    Header: (props) => <LrCustomHeader tableProps={props} title='Линия' className='min-w-250px text-gray-700' />,
    accessor: 'line',
    Cell: ({...props}) => <LrItemLine data={props.data[props.row.index].line} />,
  },
  {
    Header: (props) => <LrCustomHeader tableProps={props} title='Входящие' className='min-w-125px text-gray-700' />,
    accessor: 'incoming_count',
    Cell: ({...props}) => <LrItemValue data={props.data[props.row.index].incoming_count} />,
  },
  {
    Header: (props) => <LrCustomHeader tableProps={props} title='Пропущенные' className='min-w-125px text-gray-700' />,
    accessor: 'missed_count',
    Cell: ({...props}) => <LrItemValue data={props.data[props.row.index].missed_count} />,
  },
  {
    Header: (props) => (
      <LrCustomHeader tableProps={props} title='Уникальные входящие' className='min-w-125px text-gray-700' />
    ),
    accessor: 'incoming_unique_count',
    Cell: ({...props}) => <LrItemValue data={props.data[props.row.index].incoming_unique_count} />,
  },
  {
    Header: (props) => (
      <LrCustomHeader tableProps={props} title='Уникальные пропущенные' className='min-w-125px text-gray-700' />
    ),
    accessor: 'missed_unique_count',
    Cell: ({...props}) => <LrItemValue data={props.data[props.row.index].missed_unique_count} />,
  },
]

export {LrColumns}
